/* eslint-disable no-nested-ternary */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowTrendUp, faArrowTrendDown,
} from '@fortawesome/free-solid-svg-icons';
import H3Text from '@Uilib/h3Text';
import { TinyLine } from '@ant-design/plots';
import './style.scss';
import { Spin } from 'antd';

/**
 *
 */
function MetricWithMiniGraph({
  days, currentData, previousData, seriesData, loading, MONEY,
}) {
  const data = seriesData?.map((item) => item?.value);
  const config = {
    height: 60,
    autoFit: true,
    data,
    smooth: true,
    lineStyle: {
      stroke: '#137d84',
      lineWidth: 3,
      cursor: 'pointer',
    },
    tooltip: {
      customContent: (index, row) => (
        <div className="tooltip-value">
          {MONEY(Number(row?.[0]?.value))}
        </div>
      ),
    },
  };
  return (
    <div className="metric-with-mini-graph__wrapper">
      {loading && (
        <div className="widget-loader">
          <Spin />
        </div>
      )}
      <div className="metric-with-mini-graph">
        <div className="metric-with-mini-graph__info">
          <div className="metric-with-mini-graph__current-value">
            <H3Text text="Total Spend" className="metric-with-mini-graph__label" />
          </div>
          <div className="metric-with-mini-graph__previous-value">
            <div className="metric-with-mini-graph__label">
              {Number(currentData) > Number(previousData) ? <FontAwesomeIcon icon={faArrowTrendUp} style={{ color: 'red' }} />
                : <FontAwesomeIcon icon={faArrowTrendDown} />}
              {Number(currentData) > Number(previousData) ? <H3Text text={`+${ Number(previousData) > 0 ? ((((Number(currentData) - Number(previousData)) / Number(previousData)) * 100)?.toFixed(2)) : '0'}%`} className="metric-with-mini-graph__label-high" /> : <H3Text text={`-${Number(currentData) > 0 ? (((Number(previousData) - Number(currentData)) / Number(currentData)) * 100)?.toFixed(2) : '0' }%`} className="" /> }
            </div>
            <H3Text text={`than last ${days} days`} className="metric-with-mini-graph__value" />
          </div>
        </div>
        <H3Text text={MONEY(currentData || '0')?.split('.')?.[0]} className="metric-with-mini-graph__value" />
        {seriesData?.length > 2 && (
          <div style={{ height: '60px' }}>
            <TinyLine {...config} />
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
});

MetricWithMiniGraph.propTypes = {
  user: PropTypes.any,
  history: PropTypes.func,
  days: PropTypes.number,
  currentData: PropTypes.string,
  previousData: PropTypes.string,
  seriesData: PropTypes.array,
};

export default connect(mapStateToProps)(withRouter(MetricWithMiniGraph));
